import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { fetchReviews } from "../../actions/reviewAction";
import { withRouter } from "react-router-dom";
import { openModal } from "../../actions/modalAction";
import { Form, Button } from "semantic-ui-react";
import TextInput from "../form/TextInput";
import SelectInput from "../form/SelectInput";


//#######
const sortByO = [
  { key: "1", value: "Newest", text: "Newest" },
  { key: "2", value: "Oldest", text: "Oldest" },
  { key: "3", value: "Highest Rating", text: "Highest Rating" },
  { key: "4", value: "Lowest Rating", text: "Lowest Rating" }
];
const sortBy = () => {
  return sortByO.map((value) => ({
    key: value.key,
    text: value.text ? value.text : " N/A",
    value: value.value,
    style: { fontSize: "18px" },
  }));
};
// ***
const ratingO = [
  { key: "1", value: 1, text: "1 Star" },
  { key: "2", value: 2, text: "2 Star" },
  { key: "3", value: 3, text: "3 Star" },
  { key: "4", value: 4, text: "4 Star" },
  { key: "5", value: 5, text: "5 Star" },
];
const rating = () => {
  return ratingO.map((value) => ({
    key: value.key,
    text: value.text ? value.text : " N/A",
    value: value.value,
    style: { fontSize: "18px" },
  }));
};
// ***
const typeOfReviewO = [
  { key: "1", value:'Text', text: 'Text' },
  { key: "2", value: 'Video', text: 'Video' }
];
const typeOfReview = () => {
  return typeOfReviewO.map((value) => ({
    key: value.key,
    text: value.text ? value.text : " N/A",
    value: value.value,
    style: { fontSize: "18px" },
  }));
};
//

class ReviewSearch extends Component {
  // componentDidMount() {
  //   const { id } = this.props;
  //   this.props.fetchReview(id);
  // }
  // componentWillUnmount() {
  //   this.props.resetReview();
  // }
  onSubmit = async (values) => {
    //************
    this.props.fetchReviews(values)
    this.props.handleSearchModalClose()
    //**********
  };

  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;

    
    //*********************************
    return (
      <div className="marginBottom min-max-width">
        <div style={{ margin: "auto" }}>
          <div className="">
            {/**/}

            <div
              style={{
                textAlign: "center",
                fontSize: "1.5rem",
                fontWeight: "bold",
                padding: "15px",
                color: "dodgerblue",
              }}
            >
              {/*  */}
              Search Review
              {/*  */}
            </div>

            {/**/}
            <div className=" label">
              <Form
                style={{ padding: 20 }}
                onSubmit={handleSubmit(this.onSubmit)}
              >
                
                <Button
                  color="olive"
                  type="submit"
                  disabled={pristine || submitting}
                >
                  Search
                </Button>
                <Button
                  color="orange"
                  type="button"
                  disabled={pristine || submitting}
                  onClick={reset}
                >
                  Clear Values
                </Button>
                <Button
                  color="teal"
                  type="button"
                  onClick={this.props.handleSearchModalClose}
                >
                  Cancel
                </Button>
                <br /><br />
                
               
                {this.props.userA !== null &&
                    (this.props.userA.userType === 'admin' || this.props.userA.userType === 'manager_dwk' || this.props.userA.userType === 'manager_ggn') && 
                  (
                    <>
                      <label>Name</label>
                      <Field
                        name="name"
                        type="text"
                        component={TextInput}
                        placeholder="Name"
                      />
                    </>
                  )}
<label>Sort By</label>
                <Field
                  name="sortBy"
                  placeholder="Sort By"
                  type="text"
                  options={sortBy()}
                  //search={true}
                  component={SelectInput}
                />
                <>
                      <label>Review Type</label>
                <Field
                  name="reviewType"
                  placeholder="Review Type"
                  type="text"
                  options={typeOfReview()}
                  //search={true}
                  component={SelectInput}
                />
                    </>
                
                
                
                

                <label>Rating</label>
                <Field
                  name="rating"
                  placeholder="Rating"
                  type="text"
                  options={rating()}
                  //search={true}
                  component={SelectInput}
                />

                
                
               

                <br />

                <Button
                  color="olive"
                  type="submit"
                  disabled={pristine || submitting}
                >
                  Search
                </Button>
                <Button
                  color="orange"
                  type="button"
                  disabled={pristine || submitting}
                  onClick={reset}
                >
                  Clear Values
                </Button>
                <Button
                  color="teal"
                  type="button"
                  onClick={this.props.handleSearchModalClose}
                >
                  Cancel
                </Button>

                <br />
              </Form>
              <br />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state,
    userA: state.auth.userA,
  };
};

export default connect(mapStateToProps, {
  fetchReviews,
  openModal,
})(
  reduxForm({
    form: "ReviewSearch", // a unique identifier for this form
    destroyOnUnmount: false,
    // validate,
  })(withRouter(ReviewSearch))
);
